import { useAtomValue } from 'jotai';
import type { VectorTileSource } from 'maplibre-gl';
import { useEffect } from 'react';
import { useMap } from '@/features/map';
import { unitsAtom } from '@/features/units';
import { basemapAtom } from './basemapAtom';
import {
  CONTOUR_LABELS_LAYER,
  CONTOUR_LINES_LAYER,
  CONTOUR_PAINT,
  CONTOURS_SOURCE,
  contourLabel,
  contourTilesUrl,
} from './contours';
import { DEFAULT_MAP_LAYERS } from './defaultMap';

/** Applies basemap and unit changes to the map style. */
export function BasemapSync() {
  const map = useMap();
  const basemap = useAtomValue(basemapAtom);
  const units = useAtomValue(unitsAtom);

  useEffect(() => {
    if (!map) return;
    const sat = basemap === 'satellite';
    for (const id of DEFAULT_MAP_LAYERS) map.setLayoutProperty(id, 'visibility', sat ? 'none' : 'visible');
    map.setLayoutProperty('satellite', 'visibility', sat ? 'visible' : 'none');
    const paint = CONTOUR_PAINT[basemap];
    map.setPaintProperty(CONTOUR_LINES_LAYER, 'line-color', paint.line);
    map.setPaintProperty(CONTOUR_LABELS_LAYER, 'text-color', paint.text);
    map.setPaintProperty(CONTOUR_LABELS_LAYER, 'text-halo-color', paint.halo);
  }, [map, basemap]);

  useEffect(() => {
    if (!map) return;
    map.getSource<VectorTileSource>(CONTOURS_SOURCE)?.setTiles([contourTilesUrl(units)]);
    map.setLayoutProperty(CONTOUR_LABELS_LAYER, 'text-field', contourLabel(units));
  }, [map, units]);

  return null;
}
